import { Capacitor } from '@capacitor/core';
import { CofreBiometrico } from 'cofre-biometrico';

/**
 * A TRAVA AO ABRIR (1.4, decisão do pesquisador em 20/10/2026): opcional, em Minha conta — "Pedir Face ID / digital ao abrir
 * o aplicativo". Pede a biometria ao abrir e ao voltar depois de 5 minutos em segundo plano; nunca com uma prova aberta;
 * a senha é sempre a alternativa (`TravaDoAplicativo.tsx`).
 *
 * Por que um segredo no cofre: a única forma de exigir a biometria FORTE com a chave invalidada quando a biometria do
 * aparelho muda é abrir algo protegido por ela. Guarda-se um marcador sem valor nenhum ("trava") na mesma proteção da
 * credencial do aparelho; destravar é conseguir lê-lo. Mudou a biometria → o cofre apaga → a trava pede a senha.
 */
const CHAVE_DO_COFRE = 'trava-do-aplicativo';
const LIGADA = (userId: string | number) => `biometria:trava:${userId}`;
export const MINUTOS_EM_SEGUNDO_PLANO = 5;

export function travaLigada(userId: string | number | undefined): boolean {
  if (userId == null || !Capacitor.isNativePlatform()) return false;
  try { return localStorage.getItem(LIGADA(userId)) === 'sim'; } catch { return false; }
}

export async function ligarTrava(userId: string | number): Promise<void> {
  await CofreBiometrico.guardar({ chave: CHAVE_DO_COFRE, valor: 'trava' });
  // Ligar já confere que a biometria funciona: quem liga e não consegue abrir ficaria preso na trava.
  await CofreBiometrico.ler({ chave: CHAVE_DO_COFRE, titulo: 'Confirme para ligar a trava', botaoSenha: 'Cancelar' });
  try { localStorage.setItem(LIGADA(userId), 'sim'); } catch { /* sem armazenamento: a trava não liga */ }
}

export async function desligarTrava(userId: string | number | undefined): Promise<void> {
  if (userId != null) { try { localStorage.removeItem(LIGADA(userId)); } catch { /* nada */ } }
  await CofreBiometrico.apagar({ chave: CHAVE_DO_COFRE }).catch(() => undefined);
}

/** 'ok' destravou; 'senha' a pessoa quer a senha (ou cancelou); 'mudou' a biometria do aparelho mudou (a trava desliga). */
export async function destravar(): Promise<'ok' | 'senha' | 'mudou'> {
  try {
    await CofreBiometrico.ler({ chave: CHAVE_DO_COFRE, titulo: 'Desbloquear o Portal Simulados', botaoSenha: 'Usar a senha' });
    return 'ok';
  } catch (e) {
    const code = (e as { code?: string }).code;
    return code === 'BIOMETRIA_MUDOU' || code === 'SEM_SEGREDO' ? 'mudou' : 'senha';
  }
}
